export default "__VITE_ASSET__CsWF3zta__"